/**
 * 一般来说，2.0中的插件一般用在ssr页面，编辑页面用于代码同步和测试使用，具体代码以ssr端代码为准
 */
import specialClickShowQrCodePlugin from "./plugins/specialClickShowQrCodePlugin"
import exportPdfPlugin from "./plugins/exportPdfPlugin"
import layoutTitleOptionDrawerPlugin from "./plugins/exportPdfPlugin"
import listPageNavMenuDrawerPlugin from "./plugins/listPageNavMenuDrawerPlugin"
import appMultiFilterDrawerPlugin from "./plugins/appMultiFilterDrawerPlugin"
import drawerPlugin from "./plugins/drawerPlugin"
import popoverPlugin from "./plugins/popoverPlugin"
// 西南交大项目 显示问卷弹框
import xijiaodaShowPSQ from "./plugins/xijiaodaShowPSQ"
import downloadResources from "./plugins/downloadResources"
import getIpPlugin from "./plugins/getIpPlugin"
//收藏按钮
import collectLikeStylePlugin from "./plugins/collectLikeStylePlugin"

export default {
  mixins: [
    specialClickShowQrCodePlugin,
    exportPdfPlugin,
    layoutTitleOptionDrawerPlugin,
    xijiaodaShowPSQ,
    listPageNavMenuDrawerPlugin,
    appMultiFilterDrawerPlugin,
    drawerPlugin,
    downloadResources,
    popoverPlugin,
    getIpPlugin,
    collectLikeStylePlugin
  ]
}
